
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Calendar, ArrowRight } from "lucide-react";
import Autoplay from "embla-carousel-autoplay";

export function BlogCarousel() {
  const blogPosts = [
    {
      title: "10 Alimentos que Aceleram o Metabolismo",
      excerpt: "Descubra quais alimentos podem ajudar a aumentar seu gasto calórico naturalmente.",
      date: "15 Jan 2024",
      tag: "Nutrição",
      tagColor: "bg-brand-primary/10 text-brand-primary",
      image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=250&fit=crop"
    },
    {
      title: "Como Manter a Dieta no Final de Semana",
      excerpt: "Estratégias práticas para não sair da linha durante os fins de semana.",
      date: "12 Jan 2024",
      tag: "Hábitos",
      tagColor: "bg-brand-secondary/10 text-brand-secondary",
      image: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=400&h=250&fit=crop"
    },
    {
      title: "Hidratação e Emagrecimento",
      excerpt: "A importância da água no processo de perda de peso e como calcular sua necessidade diária.",
      date: "08 Jan 2024",
      tag: "Saúde",
      tagColor: "bg-brand-accent/10 text-brand-accent",
      image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=250&fit=crop"
    },
    {
      title: "Mitos e Verdades sobre Carboidratos",
      excerpt: "Desmistificando os carboidratos e mostrando como incluí-los de forma saudável.",
      date: "05 Jan 2024",
      tag: "Educação",
      tagColor: "bg-brand-brightGreen/10 text-brand-brightGreen",
      image: "https://images.unsplash.com/photo-1586444248902-2f64eddc13df?w=400&h=250&fit=crop"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <p className="section-label mb-2">Blog</p>
            <h2 className="section-heading">Últimas do Blog</h2>
          </div>
          <a href="/blog" className="text-brand-primary font-bold font-primary text-sm flex items-center gap-1 hover:text-brand-secondary transition-colors">
            Ver todos os artigos <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <Carousel
          className="w-full max-w-5xl mx-auto"
          plugins={[Autoplay({ delay: 4000 })]}
        >
          <CarouselContent>
            {blogPosts.map((post, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 h-full overflow-hidden group">
                  <div className="overflow-hidden relative">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <span className={`absolute top-3 left-3 text-xs font-bold font-primary px-3 py-1 rounded-full ${post.tagColor} backdrop-blur-sm`}>
                      {post.tag}
                    </span>
                  </div>
                  <div className="p-5 flex flex-col flex-grow">
                    <div className="flex items-center text-gray-400 text-xs mb-3 font-primary gap-1.5">
                      <Calendar className="w-3.5 h-3.5" />
                      {post.date}
                    </div>
                    <h3 className="text-sm font-bold mb-2 text-gray-800 leading-snug font-primary">
                      {post.title}
                    </h3>
                    <p className="text-gray-500 text-sm mb-4 flex-grow leading-relaxed font-primary font-light">
                      {post.excerpt}
                    </p>
                    <span className="text-brand-primary hover:text-brand-secondary font-bold text-sm font-primary self-start flex items-center gap-1 cursor-pointer transition-colors">
                      Ler mais <ArrowRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="border-brand-primary/20 text-brand-primary hover:bg-brand-primary hover:text-white" />
          <CarouselNext className="border-brand-primary/20 text-brand-primary hover:bg-brand-primary hover:text-white" />
        </Carousel>
      </div>
    </section>
  );
}
